import { createFileRoute, redirect } from '@tanstack/react-router';

import { faqSearchSchema } from '@/features/faq/schemas/faq-search.schema';
import { DEFAULT_LOCALE_CODE } from '@/i18n/available-locales';

export const Route = createFileRoute('/faq/volotea')({
  validateSearch: (search) => faqSearchSchema.parse({ category: search.category }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/$locale/faq/volotea',
      params: { locale: DEFAULT_LOCALE_CODE },
      search,
    });
  },
});
